import { useEffect, useState } from "react";
import ExpertDataService from "../services/Expert";
import { SingleTimingRow } from "../components/List/SingleTimingRow";
import {
  Text,
  FormControl,
  FormLabel,
  Switch,
  useToast,
} from "@chakra-ui/react";

export const ExpertTiming = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const [list, setList] = useState<any>();

  const [isSwitchOn, setIsSwitchOn] = useState(true);

  const handleSwitchChange = (event: any) => {
    setIsSwitchOn(event.target.checked);
  };

  const fetchData = async () => {
    ExpertDataService.getExperts(token, !isSwitchOn)
      .then((res: any) => {
        setList(res.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, [isSwitchOn]);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Experts - App Experts</div>
      <div className="p-4">
        <div className="top_section_container">
          <FormControl display="flex" alignItems="center">
            <FormLabel>Hide archived experts</FormLabel>
            <Switch
              id="email-alerts"
              isChecked={isSwitchOn}
              onChange={handleSwitchChange}
            />
          </FormControl>
        </div>
        {/* Main secttion */}
        <div className="main-section">
          <table className="table">
            <thead>
              <tr>
                <th className="flex-col items-start text-left">
                  <div>Name</div>
                  <Text fontWeight="300">
                    Format : <br />
                    Total Sessions Hours / <br />
                    Total Available Hours
                  </Text>
                </th>
                <th>Monday</th>
                <th>Tuesday</th>
                <th>Wednesday</th>
                <th>Thursday</th>
                <th>Friday</th>
                <th>Saturday</th>
                <th>Sunday</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleTimingRow key={el._id} props={el.data} id={el._id} />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
